import { formatDateQuery } from "constants/FormatString";
import moment, { Moment } from "moment";

// chuyển đổi "Học sinh"  => "Hocsinh"
const removeSpacesAndAccents = (text:string):string => {
  return text
  ?.toString()        // Chuyển đổi thành chuỗi
  ?.replaceAll(' ','')// Loại bỏ dấu cách
  .normalize('NFD')   // Chuẩn hóa chuỗi thành dạng NFD
  .replace(/[\u0300-\u036f]/g, '')  // Loại bỏ dấu câu
  .replace(/đ/g, 'd') // Thay thế 'đ' bằng 'd'
  .replace(/Đ/g, 'D') // Thay thế 'Đ' bằng 'D')
  .replace(/[^a-zA-Z0-9]/g, ''); // Loại bỏ tất cả các ký tự không phải là chữ cái hoặc số
};
// chuyển đổi "Học sinh."  => "HOCSINH"
const removeSpacesAndAccents_toUpperCase = (text: string):string => {
  return removeSpacesAndAccents(text)
    ?.toUpperCase();
};

//"he<ll>o, i'm J<o>hn" ==> ["he", "<ll>", "o, i'm J", "<o>", "hn"]
function convertStringToArrayByRegex(str:string, regex = /(<|>)/g) {
  // Sử dụng biểu thức chính quy để tìm tất cả các vị trí có chứa "<" hoặc ">"
  const matches = [...str.matchAll(regex)];
  
  // Tạo một mảng các vị trí cắt
  const indexes = matches.map(match => match.index);
  
  // Tạo danh sách các phần cắt
  const splits = [];
  let start = 0;
  for (const index of indexes) {
      splits.push(str.slice(start, index));
      splits.push(str.slice(index, index + 1));
      start = index + 1;
  }
  // Thêm phần còn lại của chuỗi
  splits.push(str.slice(start));
  
  // Loại bỏ các phần rỗng
  return splits.filter(part => part !== "");
}

const renderLongText = (str:string, length:number = 50) =>{
  return str.length > length ? str.slice(0, length) + '...' : str;
}

const formatCapitalizeTheFirstCharacter = (str: string, length: number = 50) => {
  return str
    .split('')
    .map((item, index) => {
      if (index === 0) {
        return item.toUpperCase();
      } else {
        return item.toLowerCase();
      }
    })
    .join('');
};

function convertStringToDate(date?: string): Moment | undefined {
  //'1900-01-01T00:00:00' là ngày mặc định khi người dùng không nhập ngày nên không hiển thị
  return date && !date.includes('1900-01-01') ? moment(date) : undefined;
}
function convertDateToString(date: Moment, format: string = formatDateQuery): string | undefined {
  return date ? moment(date).format(format) : undefined;
}

export { removeSpacesAndAccents, removeSpacesAndAccents_toUpperCase, convertStringToArrayByRegex, renderLongText, formatCapitalizeTheFirstCharacter ,convertStringToDate,convertDateToString};
